import React from 'react';
import { ArrowRight, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { locations } from '../mock';

const Locations = () => {
  return (
    <section id="locations" className="py-16 lg:py-24 bg-white">
      <div className="max-w-[1240px] mx-auto px-6">
        <div className="grid lg:grid-cols-[1fr_320px] gap-10 items-end mb-10">
          <h2 className="text-[40px] lg:text-[54px] leading-[0.98] font-bold tracking-tight text-neutral-900">
            Our <span className="font-serif-italic font-normal">Clinics</span>
          </h2>
          <div>
            <p className="text-[15px] leading-relaxed text-neutral-600">
              Three welcoming locations. Same evidence-informed care, same friendly team.
            </p>
            <Link to="/locations" className="mt-3 inline-flex items-center gap-1 text-[14px] font-medium text-[#CA0028] group">
              View All Clinics
              <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {locations.map((loc) => (
            <Link key={loc.id} to={`/locations/${loc.slug}`} className="group">
              <div className="rounded-[20px] overflow-hidden aspect-[4/3] bg-neutral-100">
                <img
                  src={loc.image}
                  alt={loc.name}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <h3 className="mt-5 text-[19px] font-semibold text-neutral-900 group-hover:text-[#CA0028] transition-colors">{loc.name}</h3>
              <p className="mt-2 text-[14px] text-neutral-600 leading-relaxed">{loc.address}</p>
              <span className="mt-3 inline-flex items-center gap-2 text-[14px] font-medium text-[#CA0028]">
                <Phone size={14} />
                {loc.phone}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Locations;
